<template>
  <div class="group-name-section">
    <div v-for="(item, index) in groups"
         :key="item.id"
         :id="item.id"
         class="group-name"
         @click="isOnlySelected ? null : $emit('setSelectedItem', item.id)">
      <div class="group-name-text">
        <span><template v-if="!hideGroupName">{{item.name.replace(/\_/g, ' ')}}</template></span>
        <span v-if="canShowSubConfigDate && subConfigsGroupNames.includes(item.name)"
              class="group-name-sub-config"> ({{displayDate}})</span>
        <span v-if="isOnlySelected && !hideGroupName">:</span>
        <span v-if="!isOnlySelected && item.display_names"
              class="has-selected-filters">
          {{item.display_names.length}}
        </span>
        <span v-if="headset(item)">
          <svg viewBox="-1 0 30 25" class="headset-icon">
            <use xlink:href="#headset-icon"></use>
          </svg>
        </span>
      </div>
      <group-name-tags v-if="item.display_names && isOnlySelected"
                       :hideGroupName="hideGroupName"
                       :isInLastGroup="index === (groups.length - 1)"
                       :selectedNames="item.display_names"></group-name-tags>
    </div>
  </div>
</template>

<script>
  import GroupNameTags from './GroupNameTags'

  export default {
    props: {
      displayDate: String,
      groups: Array,
      hideGroupName: Boolean,
      isOnlySelected: Boolean,
      subConfigsGroupNames: Array,
    },

    name: 'GroupNames',

    components: {
      GroupNameTags,
    },

    methods: {
      headset(item) {
        return item.name == 'headset segments'
      },
    },

    computed: {
      canShowSubConfigDate: function() {
        return this.displayDate && this.isOnlySelected && this.subConfigsGroupNames
      },
    },
  }
</script>
